import { FiltersChangedEvent } from '@theme/events';

class FilterComponent extends HTMLElement {
  constructor() {
    super();

    this.form = null;
  }

  connectedCallback() {
    this.form = this.querySelector('[data-ref="filters-form"]');

    this.addEventListener('change', this.#onFiltersChanged);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onFiltersChanged);
  }

  #onFiltersChanged = (event) => {
    event.preventDefault();

    const sizeMaster = event.target.closest('[data-filter-size-master]');
    if (sizeMaster) {
      const groupId = CSS.escape(sizeMaster.dataset.filterSizeMaster);
      this.querySelectorAll(`[data-filter-size-alias="${groupId}"]`).forEach((aliasInput) => {
        aliasInput.checked = sizeMaster.checked;
      });
    }

    // A sale product can be in stock in another size. Keep size counts honest
    // without changing an explicit availability choice made by the customer.
    const isSaleCollection = /^\/collections\/bonnes-affaires(?:-|\/|$)/.test(window.location.pathname);
    const isSizeChange = Boolean(sizeMaster) || event.target.name?.includes('filter.v.option.taille');
    if (isSaleCollection && isSizeChange) {
      const selectedSize = this.form.querySelector('input[name*="option.taille"]:checked, input[name*="option.size"]:checked');
      const availabilityChoice = this.form.querySelector('input[name="filter.v.availability"]:checked');
      if (selectedSize && !availabilityChoice) {
        const inStock = this.form.querySelector('input[name="filter.v.availability"][value="1"]');
        if (inStock) inStock.checked = true;
      }
    }

    const filterParams = this.getFiltersParams();
    const sortingParams = this.closest('filter-and-sort-component').getCurrentSortingParams();

    document.dispatchEvent(new FiltersChangedEvent(filterParams, sortingParams));
  };

  getFiltersParams() {
    const formData = new FormData(this.form);
    const newParameters = new URLSearchParams(formData);

    if (newParameters.get('filter.v.price.gte') === '') newParameters.delete('filter.v.price.gte');
    if (newParameters.get('filter.v.price.lte') === '') newParameters.delete('filter.v.price.lte');

    newParameters.delete('page');

    return newParameters.toString();
  }

  renderFilters(newFiltersHtml) {
    this.innerHTML = newFiltersHtml.innerHTML;
    this.form = this.querySelector('[data-ref="filters-form"]');
  }
}

if (!customElements.get('filter-component')) {
  customElements.define('filter-component', FilterComponent);
}
